<template>
  <EditDesign
    v-if="!loading"
    ref="edit-invoice-design"
    :invoice="invoice"
    :recipient="recipient"
    :totals="totals"
    :show-controls="showControls"
    :on-modal="onModal"
    @changed="hasChanges = true"
    @saved="$emit('updated')"
    @pdf-loaded="$emit('pdf-loaded')"
  />
</template>

<script>
import { mapGetters } from "vuex";

import GekkoButton from "@/components/GekkoButton";
import EditDesign from "@/components/invoices/EditDesign"

import CustomerService from "@/store/services/customer.service.js";

export default {
  name: 'InvoiceDesign',
  components: {
    GekkoButton,
    EditDesign
  },
  props: {
    showControls: {
      type: Boolean,
      default: true
    },
    onModal: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      invoice: {},
      totals: {},
      recipient: null,
      loading: true,
      hasChanges: false
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: 'main/getCurrentCompany',
      selectedBrand: 'brands/getSelectedBrand'
    })
  },
  created () {
    this.setupData()
  },
  beforeRouteLeave (to, from , next) {
    if (this.hasChanges) {
      const ConfirmModalConstructor = this.$options.components['confirm-modal']
      const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
        title: this.$gettext('Leaving this page'),
        message: this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'),
        options: {
          variant: 'primary',
          confirmText: this.$gettext('Ok')
        }
      }})
      confirmModalInstance.$mount()
      document.body.appendChild(confirmModalInstance.$el)
      confirmModalInstance.$on('confirmed', () => {
        if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
          confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
        }
        next()
      })
      confirmModalInstance.$on('cancel', () => {
        if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
          confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
        }
      })
    } else {
      next()
    }
  },
  methods: {
    setupData () {
      this.invoice = {
        "number": "000001",
        "invoice_date": new Date().format('Y-m-d'),
        "payment_term": 30,
        "sender_company": this.currentCompany.id,
        "vat_reversed_charge": true,
        "line_amount_is_gross": true,
        "recipient_customer": 3,
        "invoice_lines": [
          { "order": 0, "multiplier": 1, "amount": 1, "line_amount_is_gross": null, "subtotal_amount": 0, "tax_rate": 0, "description": this.$gettext("Online account for invoices and overview"), "product": null, "vat_exempt": false },
          { "order": 0, "multiplier": 1, "amount": 1, "line_amount_is_gross": null, "subtotal_amount": 0, "tax_rate": 0, "description": this.$gettext("Hours App"), "product": null, "vat_exempt": false },
          { "order": 0, "multiplier": 1, "amount": 1, "line_amount_is_gross": null, "subtotal_amount": 0, "tax_rate": 0, "description": this.$gettext("Costs App"), "product": null, "vat_exempt": false },
          { "order": 0, "multiplier": 1, "amount": 1, "line_amount_is_gross": null, "subtotal_amount": 0, "tax_rate": 0, "description": this.$gettext("Trips App"), "product": null, "vat_exempt": false },
          { "order": 0, "multiplier": 1, "amount": 1, "line_amount_is_gross": null, "subtotal_amount": 0, "tax_rate": 0, "description": this.$gettext("Backed up & secure in the cloud"), "product": null, "vat_exempt": false },
        ],
        "language": "nl",
        "currency": "EUR",
        "brand_id": null,
        "invoice_payment": { "payment_type": "cash", "amount": 0, "payment_date": "" },
        "retention_tax_amount": null,
        "retention_tax_percentage": null,
        "reference": "REF-12345",
        "project": null
      }
      if (this.selectedBrand && this.selectedBrand.id) {
        this.invoice.brand_id = this.selectedBrand.id
      }
      this.totals = { "vat_totals": [[0]], "subtotal": 0, "total": 0 }
      CustomerService.listPaginated({ owner_company: this.currentCompany.id, contact_type: 'customer' }).then((response) => {
        const customers = response.data.results.filter(item => item.id !== this.currentCompany.id)
        if (customers.length > 0) {
          this.recipient = customers[0].id
        }
        this.loading = false
      })
    },
    saveChanges () {
      this.hasChanges = false
      this.$refs['edit-invoice-design'].saveChanges()
    }
  },
}
</script>

<style lang="scss" scoped>
  .setting-content--section {
    padding: 0 !important;
    overflow: hidden;
  }
</style>